<template>
    <div class="wallet-modal-backdrop" @click.self="$emit('close')">
        <div class="modal-card" role="dialog" :aria-label="$t('userWallet.receive.title')">
            <div class="modal-header">
                <div class="modal-title-row">
                    <img id="receiveLogo" src="/assets/images/wallets/ethereum.svg" alt="" width="28" height="28">
                    <h2 id="receiveTitle">{{ $t('userWallet.receive.title') }}</h2>
                </div>
                <button class="icon-button" type="button" :aria-label="$t('userWallet.close')" @click="$emit('close')">
                    <img src="/assets/images/wallets/close.svg" alt="" width="22" height="22">
                </button>
            </div>

            <div class="modal-body">
                <p class="receive-note">{{ $t('userWallet.receive.note') }}</p>

                <img v-if="qrCodeSrc" :src="qrCodeSrc" class="qr-canvas" alt="QR">

                <label class="field">
                    <span>{{ $t('userWallet.receive.addressLabel') }}</span>
                    <span class="copy-field">
                        <input type="text" :value="address" readonly>
                        <button type="button" class="secondary-button" @click="copyAddress">
                            {{ $t('userWallet.receive.copy') }}
                        </button>
                    </span>
                </label>
                <p class="inline-status" aria-live="polite">{{ copied ? $t('userWallet.receive.copied') : '' }}</p>
            </div>

            <div class="modal-actions centered">
                <button class="secondary-button" type="button" @click="$emit('close')">
                    {{ $t('userWallet.close') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcode';

    export default {
        name: 'WalletReceiveModal',

        props: {
            address: {type: String, required: true},
        },

        data() {
            return {
                qrCodeSrc: null,
                copied: false,
            };
        },

        async created() {
            if (this.address) {
                this.qrCodeSrc = await QRCode.toDataURL(this.address, {width: 152, errorCorrectionLevel: 'H'});
            }
        },

        methods: {
            copyAddress() {
                navigator.clipboard.writeText(this.address).then(() => {
                    this.copied = true;
                });
            },
        },
    };
</script>
